import { defineComponent as _defineComponent } from 'vue'
import { debounce } from "@/utils/Helpers";
import {useTranslations} from "@/hooks/useTranslations";
import {ref, watch} from "vue";

type UserLicensesFormProps = {
  value: number;
  freeUserLicenses: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLicensesForm',
  props: {
    value: null,
    freeUserLicenses: null
  },
  emits: ["change", "update:value"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: number;
  freeUserLicenses: number;
};




const payingUserLicenses = ref(props.value);

const translations = useTranslations();

watch(payingUserLicenses, (newValue) => {
  emit("update:value", newValue);
  debounce(
    () => emit("change", newValue),
    1500,
    "user_licenses_form"
  );
});

function removeLicense() {
  if (payingUserLicenses.value > 0) {
    payingUserLicenses.value--;

    //Check the migration type after removing licenses
    emit("change");
  }
}

//Add license to payment modal
function addLicense() {
  payingUserLicenses.value++;

  //Check the migration type after adding licenses
  emit('change');
}

return { __sfc: true,props, emit, payingUserLicenses, translations, removeLicense, addLicense }
}

})